<template>
  <div style="text-align: center">
    <v-icon class="fas fa-pencil-alt pencil"></v-icon>
  </div>
</template>

<script>
export default {
  name: "icon-pencil"
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables";
.pencil {
  color: $submit-color;
  font-size: 20px;
}
</style>
